import AWS from 'aws-sdk';
// Heapsgood
const accessKeyId = 'AKIA5FTZFMUWXLNKLEIE';
const secretAccessKey = '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';
// Studio Alt
// const accessKeyId = 'AKIASMNJQEDNOOZOH5PG';
// const secretAccessKey = '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';
AWS.config.update({
    region: 'ap-southeast-2',
    credentials: new AWS.Credentials(accessKeyId, secretAccessKey),
});
const s3 = new AWS.S3({ apiVersion: '2006-03-01' });
export default s3;
